import { connectMenu } from 'react-instantsearch-dom';

import {} from '@material-ui/core';
import FacetList from './FacetList';

const ConnectedMenu = connectMenu(FacetList);
export default ConnectedMenu;



// WEBPACK FOOTER //
// ./src/components/Algolia/ConnectedMenu.js